// IT Sales Partners Constants
export const GET_ITSALES_PARTNERS_REQUEST = 'GET_ITSALES_PARTNERS_REQUEST';
export const GET_ITSALES_PARTNERS_SUCCESS = 'GET_ITSALES_PARTNERS_SUCCESS';
export const GET_ITSALES_PARTNERS_FAILURE = 'GET_ITSALES_PARTNERS_FAILURE';

export const ADD_ITSALES_PARTNER_REQUEST = 'ADD_ITSALES_PARTNER_REQUEST';
export const ADD_ITSALES_PARTNER_SUCCESS = 'ADD_ITSALES_PARTNER_SUCCESS';
export const ADD_ITSALES_PARTNER_FAILURE = 'ADD_ITSALES_PARTNER_FAILURE';

export const EDIT_ITSALES_PARTNER_REQUEST = 'EDIT_ITSALES_PARTNER_REQUEST';
export const EDIT_ITSALES_PARTNER_SUCCESS = 'EDIT_ITSALES_PARTNER_SUCCESS';
export const EDIT_ITSALES_PARTNER_FAILURE = 'EDIT_ITSALES_PARTNER_FAILURE';

export const DELETE_ITSALES_PARTNER_REQUEST = 'DELETE_ITSALES_PARTNER_REQUEST';
export const DELETE_ITSALES_PARTNER_SUCCESS = 'DELETE_ITSALES_PARTNER_SUCCESS';
export const DELETE_ITSALES_PARTNER_FAILURE = 'DELETE_ITSALES_PARTNER_FAILURE';

export const CHANGE_ITSALES_STATUS_REQUEST = 'CHANGE_ITSALES_STATUS_REQUEST';
export const CHANGE_ITSALES_STATUS_SUCCESS = 'CHANGE_ITSALES_STATUS_SUCCESS';
export const CHANGE_ITSALES_STATUS_FAILURE = 'CHANGE_ITSALES_STATUS_FAILURE';

export const RESET_ITSALES_PASSWORD_REQUEST = 'RESET_ITSALES_PASSWORD_REQUEST';
export const RESET_ITSALES_PASSWORD_SUCCESS = 'RESET_ITSALES_PASSWORD_SUCCESS';
export const RESET_ITSALES_PASSWORD_FAILURE = 'RESET_ITSALES_PASSWORD_FAILURE';

export const GET_ITSALES_LICENSES_REQUEST = 'GET_ITSALES_LICENSES_REQUEST';
export const GET_ITSALES_LICENSES_SUCCESS = 'GET_ITSALES_LICENSES_SUCCESS';
export const GET_ITSALES_LICENSES_FAILURE = 'GET_ITSALES_LICENSES_FAILURE';

// IT Sales OEM Partners Constants
export const GET_ITSALES_PARTNER_OEM_LIST_REQUEST = 'GET_ITSALES_PARTNER_OEM_LIST_REQUEST';
export const GET_ITSALES_PARTNER_OEM_LIST_SUCCESS = 'GET_ITSALES_PARTNER_OEM_LIST_SUCCESS';
export const GET_ITSALES_PARTNER_OEM_LIST_FAILURE = 'GET_ITSALES_PARTNER_OEM_LIST_FAILURE';

// IT Sales OEM Users Constants
export const GET_ITSALES_PARTNER_OEM_USERS_REQUEST = 'GET_ITSALES_PARTNER_OEM_USERS_REQUEST';
export const GET_ITSALES_PARTNER_OEM_USERS_SUCCESS = 'GET_ITSALES_PARTNER_OEM_USERS_SUCCESS';
export const GET_ITSALES_PARTNER_OEM_USERS_FAILURE = 'GET_ITSALES_PARTNER_OEM_USERS_FAILURE';

// Resend Verification Email
export const RESEND_ITSALES_VERIFICATION_EMAIL_REQUEST = 'RESEND_ITSALES_VERIFICATION_EMAIL_REQUEST';
export const RESEND_ITSALES_VERIFICATION_EMAIL_SUCCESS = 'RESEND_ITSALES_VERIFICATION_EMAIL_SUCCESS';
export const RESEND_ITSALES_VERIFICATION_EMAIL_FAILURE = 'RESEND_ITSALES_VERIFICATION_EMAIL_FAILURE';